export default function createObserver() {
  var subscribers = [];

  function subscribe(subscriber) {
    subscribers.push(subscriber);

    function unsubscribe() {
      var index = subscribers.indexOf(subscriber);
      subscribers.splice(index, 1);
    }

    return {
      unsubscribe: unsubscribe
    };
  }

  function notify(subject) {
    subscribers.map(function (subscriber) {
      return subscriber(subject);
    });
  }

  return {
    subscribe: subscribe,
    notify: notify
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/lib/esm/createObserver.js
// module id = 321
// module chunks = 0 1